import { Box, Button, Flex } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AppContext from 'src/AppContext';
import styled from 'styled-components';
import UploadLocalFile, { UploadedFile } from '../addNewLicenseSystemToOrg/UploadLocalFile';

export interface AddNewLicenseSystemToOrgModalProps {
    onClose?: () => void;
    onSubmit: (fileContent: string) => void;
};

const RepairLicenseSystemModal: FunctionComponent<AddNewLicenseSystemToOrgModalProps> = (props) => {
    const { t } = useTranslation();
    const context = useContext(AppContext);
    const [deviceFileFromDisk, setDeviceFileFromDisk] = useState<undefined | UploadedFile>(undefined);

    return (
        <Flex mr="24px" ml="24px" flexDirection="column" gap='40px'>
            <Flex className="px12_400_normal" gap='16px' flexDirection="column">
                <p>
                    {t('RepairLicenseSystemModal.paragraph1_desc', 'Please upload your device file. You can get the device file in the Application Service of this system via the menu, clicking "Create device file". Transfer and upload this file here to receive a repair file for your system.')}
                </p>
                <Box>
                    <Trans t={t} i18nKey={'RepairLicenseSystemModal.paragraph2_desc'}>
                        For more information on repairing license systems and reactivating the file, please refer to our&nbsp;
                        <ColoredLink
                            aria-label="call to helpCenter button"
                            to={context.language === 'de'
                                ? 'https://customercare.gmgcolor.com/hc/de-de/articles/31531181801883-Online-Licensing-im-Offline-Modus'
                                : 'https://customercare.gmgcolor.com/hc/en-us/articles/31531181801883-Online-Licensing-in-Offline-Mode-High-Security-Systems'
                            }
                            target="_blank"
                            rel="noreferrer"
                        >
                            Help Center
                        </ColoredLink>
                    </Trans>
                </Box>
            </Flex>

            <UploadLocalFile
                id={'deviceFile'}
                label={t('AddNewLicenseSystemToOrg.input_deviceFile_label', 'Upload device file')}
                acceptedFileFormat='.lic'
                buttonProps={{ title: t('AddNewLicenseSystemToOrg.select_btn', 'Select file'), variant: 'primary' }}
                onFinishUpload={setDeviceFileFromDisk}
            />

            <Flex justifyContent="flex-end" gap="10px">
                <Button
                    variant="primary"
                    type="submit"
                    disabled={!deviceFileFromDisk}
                    onClick={() => {
                        props.onSubmit(deviceFileFromDisk!.content);
                        props.onClose?.();
                    }}
                >
                    {t('ButtonTitles.action_continue_btn', 'Continue')}
                </Button>
                <Button
                    variant="secondary"
                    type="reset"
                    onClick={() => props.onClose?.()}
                >
                    {t('ButtonTitles.action_cancel_btn', 'Cancel')}
                </Button>
            </Flex>
        </Flex>
    );
};

const ColoredLink = styled(Link)`
    color: ${props => props.theme.colors.highlight};
`;

export default RepairLicenseSystemModal;